import React from 'react';
import { Lightbulb, Rocket, CheckCircle, BarChart3, RefreshCw, ArrowRight } from 'lucide-react';

const steps = [
  {
    icon: Lightbulb,
    title: 'Create',
    description: 'Clawd generates a unique meme concept, brand identity, and visual design.',
  },
  {
    icon: Rocket,
    title: 'Launch',
    description: 'Token is deployed on Base.',
  },
  {
    icon: CheckCircle,
    title: 'Confirm',
    description: 'Clanker confirms the deployment on-chain.',
  },
  {
    icon: BarChart3,
    title: 'Monitor',
    description: 'Agent monitors market activity and treasury.',
  },
  {
    icon: RefreshCw,
    title: 'Buyback',
    description: 'Profits buy back $CFACTORY tokens in ETH.',
  },
];

const HowItWorks = () => {
  return (
    <section id="how" className="py-24 px-6 relative z-10">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl font-display font-bold text-white mb-4">How It Works</h2>
          <p className="text-white/50 max-w-xl mx-auto">
            A fully autonomous cycle from concept to buyback
          </p>
        </div>

        {/* Steps */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="glass-card p-6 w-full md:w-48 text-center group hover:border-[#ff3b3b]/30 transition-all">
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-[#ff3b3b]/20 flex items-center justify-center group-hover:bg-[#ff3b3b]/30 transition-colors">
                  <step.icon className="w-6 h-6 text-[#ff3b3b]" />
                </div>
                <span className="text-[#ff3b3b] text-xs font-semibold mb-2 block">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="text-white font-display font-bold mb-2">{step.title}</h3>
                <p className="text-white/40 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <ArrowRight className="hidden md:block w-5 h-5 text-white/20 flex-shrink-0" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
